// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toQueryParams = (obj: Record<any, any>) => {
  const str = [];

  for (const key in obj) {
    if (obj.hasOwn(key) && obj[key]) {
      str.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
    }
  }

  return str.join("&");
};
